import React, { useRef, useState, forwardRef, } from 'react';
import { Box, HStack, Textarea, IconButton } from '@chakra-ui/react'

import send from "./assets/send.svg"


//import { ReactComponent as MicroPhone } from "./microphone-342.svg";
import { FiMic } from "react-icons/fi";

const Footer = forwardRef(({ txts, promptEntry, updateFooterHeight, micClick, recActive, ...props }, ref) => {

  //const Footer = ({ promptEntry,updateFooterHeight }) => {

  //const prompt = useRef();
  const currentHeight = useRef(0);
  const [height, setHeight] = useState(40);

  return <>

    <Box mt={"32px"} >
      <HStack>
        <IconButton colorScheme={`${recActive ? "red" : "whatsapp"}`} onClick={micClick}
          aria-label='Mic'
          fontSize='20px'
          icon={<FiMic />} />
        <Textarea id="prompt" ref={ref} maxHeight={"250px"} minHeight={"40px"} h={height + "px !important"} onChange={() => {
          //console.log(ref.current.getBoundingClientRect());
          //console.log(ref.current.scrollHeight);

          if (ref.current.scrollHeight > currentHeight.current && currentHeight.current === 0) {
            currentHeight.current = ref.current.scrollHeight;
          }
          // new row ....
          if (ref.current.scrollHeight > currentHeight.current && currentHeight.current < 250) {
            // console.log("NEW HEIGHT ");
            currentHeight.current = ref.current.scrollHeight;
            ref.current.Height = ref.current.scrollHeight;
            setHeight(ref.current.scrollHeight);
            updateFooterHeight(ref.current.scrollHeight + 70);
          }

        }} placeholder={txts.ask} w={{ base: "290px", lg: "460px", xl: "760px" }} bg={"white"} resize={"none"}
          onKeyDown={e => {
            if (e.key === "Enter") {
              e.preventDefault();
              setHeight(40);
              if (ref.current.value !== "") {
                promptEntry();
              }

            }
          }}
          maxLength={process.env.REACT_APP_PRIFINA_WISDOM_MAX_PROMPT}
        />

        <img id="send-prompt" src={send} width={"20px"} style={{ cursor: "pointer" }} onClick={(e) => {
          e.preventDefault();
          setHeight(40);
          if (ref.current.value !== "") {
            promptEntry();
          }
        }} alt={"send"} />
      </HStack>

    </Box>
  </>
});

export default Footer;